import { render, staticRenderFns } from "./RevokeVoucherModal.vue?vue&type=template&id=0296f06d&scoped=true"
import script from "./RevokeVoucherModal.vue?vue&type=script&lang=js"
export * from "./RevokeVoucherModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296f06d",
  null
  
)

export default component.exports